import { useNotificationStore } from '@dashboard/stores/notificationStore'
import type { NotificationType } from '@dashboard/stores/notificationStore'
import type { ToastMessageOptions } from 'primevue/toast'
import type { ToastServiceMethods } from 'primevue/toastservice'
import { PrimeVueToastSymbol } from 'primevue/usetoast'
import type { Plugin } from 'vue'

// Stands in for PrimeVue's ToastService: `useToast()`, `inject('toast')` and
// `$toast` keep their API, and their messages join the notification stack.
// As with PrimeVue, a message without `life` stays until it is dismissed.
const TYPE_BY_SEVERITY: Record<string, NotificationType> = { success: 'success', error: 'error', warn: 'warn' }

export const notificationToastService: Plugin = {
  install(app) {
    const ids = new WeakMap<ToastMessageOptions, number>()
    const service: ToastServiceMethods = {
      add(message) {
        const detail = typeof message.detail === 'string' && message.detail !== '' ? message.detail : undefined
        const id = useNotificationStore().add({
          message: message.summary || detail || '',
          detail: message.summary ? detail : undefined,
          type: TYPE_BY_SEVERITY[message.severity ?? ''] ?? 'info',
          sticky: message.life === undefined,
          life: message.life,
          group: message.group
        })
        ids.set(message, id)
      },
      remove(message) {
        const id = ids.get(message)
        if (id !== undefined) {
          useNotificationStore().dismiss(id)
        }
      },
      removeGroup(group) {
        useNotificationStore().removeGroup(group)
      },
      removeAllGroups() {
        useNotificationStore().clear()
      }
    }
    app.config.globalProperties.$toast = service
    app.provide(PrimeVueToastSymbol, service)
  }
}
